// ResendEmailDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const ResendEmailDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle><span className="heading-4 color-dark">Re-send Email</span></DialogTitle>

      <DialogContent>
       <span className="large-bold color-dark">Are you sure you want to re-send the email?</span>
      </DialogContent>

      <DialogActions>
        <AButton onClick={onClose} variant="outline_danger">
          No
        </AButton>
        <AButton onClick={onConfirm} variant="primary_filled">
          Yes
        </AButton>
      </DialogActions>
    </Dialog>
  );
};

export default ResendEmailDialog;